import { render, staticRenderFns } from "./DonutChartsCallsReport.vue?vue&type=template&id=ddc032ee&scoped=true"
import script from "./DonutChartsCallsReport.vue?vue&type=script&lang=js"
export * from "./DonutChartsCallsReport.vue?vue&type=script&lang=js"
import style0 from "./DonutChartsCallsReport.vue?vue&type=style&index=0&id=ddc032ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc032ee",
  null
  
)

export default component.exports